import { PropaneSharp } from '@mui/icons-material';
import * as React from 'react';

import { useEffect } from 'react';

export default function TabSelector({handleTabs,title}) {
  const [value, setValue] = React.useState(1);
  useEffect(()=>{

    handleTabs(1)

  },[])


  const handleChange = (event, newValue) => {
    setValue(newValue);

    //const res = syms.filter(sym=>parseFloat(sym.buy) === 1)

      handleTabs(newValue)

  };

  return (
    <div>



        <div>
        <div>

                <div className='subtabs2020'> 


                    <div className={`tab2443 tab3 ${value == 1 ? 'tab2443-active' : ''}`} onClick={(event)=>handleChange(event,1)}>
                        سریع



                    </div>

                    {title !='USDT' ? 

                    <>
                    
                    
                    <div  className={`tab2443 tab3 ${value == 2 ? 'tab2443-active' : ''}`} onClick={(event)=>handleChange(event,2)}>
                        تعیین قیمت

                    </div>


                    <div  className={`tab2443 tab3 ${value == 3 ? 'tab2443-active' : ''}`} onClick={(event)=>handleChange(event,3)}>
                       حد سود و زیان

                    </div>

                    </>
                    :
                    <></>

                    }


             
           

                 


                    <span>
                      
                    </span>




                </div>



</div>
    



        </div>
    </div>
  );
}



